<template>
  <header class="header-expanded bg-white px-4 py-2 relative box-border w-full hiver-widget-header__wrapper w-100" :class="{'pl-4': avatarUrl}">
    <div 
      v-if="isSurfaceKbEnabled"
      class="back-icon-wrapper"
      @click="goToHomeTab"
    >
      <img :src="backIcon" alt="Back Icon" /> 
    </div>
    <div class="flex justify-between items-start hiver-widget-header__wrapper--image">
      <img v-if="avatarUrl" class="logo" :src="avatarUrl" />
    </div>
    <div class="hiver-widget-header__wrapper--text">
        <h2 v-html="introHeading" :class="{ 'kb-in-chat-intro-heading': isSurfaceKbEnabled }"/>
        <p v-html="introBody" :class="{ 'kb-in-chat-intro-body': isSurfaceKbEnabled }"/>
    </div>
    <header-actions 
      :show-popout-button="showPopoutButton"
      :conversation-attributes="conversationAttributes" 
    />
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import HeaderActions from './HeaderActions';
import backIcon from '../assets/images/backIcon.svg';
import configMixin from "../mixins/configMixin";
import { TAB_TYPE } from "../helpers/constants";

export default {
  name: 'ChatHeaderExpanded',
  components: {
    HeaderActions,
  },
  mixins: [ configMixin],
  props: {
    avatarUrl: {
      type: String,
      default: '',
    },
    introHeading: {
      type: String,
      default: '',
    },
    introBody: {
      type: String,
      default: '',
    },
    showPopoutButton: {
      type: Boolean,
      default: false,
    },
    conversationAttributes: {
      type: Object,
      default: null,
    },
    chatTabProps: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      backIcon,
    }
  },
  computed: {
    ...mapGetters({ 
      widgetColor: 'appConfig/getWidgetColor',
      webChannelConfig: 'appConfig/getWebChannelConfig',
    }),
    isSurfaceKbEnabled() {
      return this.isSurfaceKBInLiveChatEnabled;
    },
  },
  methods: {
    goToHomeTab() {
      localStorage.setItem('presentTab', TAB_TYPE.HOME);
      window.bus.$emit('home-tab-clicked');
      this.$router.push({
        path: '/home',
        query: {
          ...this.chatTabProps,
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import '~widget/assets/scss/mixins.scss';

$logo-size: 32px;

.header-expanded {
    overflow-wrap: break-word;
    width: fit-content;
  .logo {
    width: $logo-size;
    height: $logo-size;
    border-radius: $logo-size;
  }
}

.hiver-widget-header__wrapper {
  display: flex;
  align-items: center;
  min-height: 75px;
  width: 100%;
  &--image {
    padding-right: 12px;
    img {
        min-width: 32px;
    }
  }
  &--text {
    h1 {
      font-size: 16px;
      font-weight: 500;
      line-height: 28px;
      letter-spacing: 0.20000000298023224px;
      text-align: left;
      font-variation-settings: 'wdth' 100;
      color: #282828;
    }
    p {
      font-size: 13px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0.0025em;
      text-align: left;
      color: #6c7b94;
      margin-top: 2px;
    }
  }
}
.kb-in-chat-intro-heading {
  color: #282828;
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0.2px;
  text-align: left;
  font-variation-settings: 'wdth' 100;
  word-break: break-word;
  overflow-wrap: break-word;
}
.kb-in-chat-intro-body {
  font-family: 'Open Sans', sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.0025em;
  text-align: left;
  color: #6F7C90;
  word-break: break-word;
  overflow-wrap: break-word;
}
.back-icon-wrapper {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  &:hover {
    background-color: #0F13160A;
  }
}
.back-icon-wrapper img {
  max-width: none;
}
</style>